<template>
  <div>
    <Head title="Create Mail Template" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link href="/settings">Settings</Link></li>
        <li class="breadcrumb-item"><Link href="/settings/mail/inserts">Mail Inserts</Link></li>
        <li class="breadcrumb-item active" aria-current="page">Create Mail Insert</li>
      </ol>
    </nav>
    <h1>Create Mail Insert</h1>

    <div class="content-box">
      <form @submit.prevent="store">
        <MailInsertForm :form="form" />

        <div class="actions-toolbar">
          <loading-button :loading="form.processing" class="btn btn-primary" type="submit">Create Insert</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import MailInsertForm from './components/MailInsertForm'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    MailInsertForm,
    LoadingButton,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        group: 'customer',
        sort: null,
        html_template: null
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/settings/mail/inserts')
    },
  },
}
</script>
